<label class="title-dialog" mat-dialog-title>{{'verify-enterprice.sign_title' | translate}}
  <button (click)="onClickBtnCancel()" aria-label="Close"  class="close" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" width="15.849" height="15.85" viewBox="0 0 15.849 15.85" fill="none">
      <path d="M14.3641 0.721576L8.00006 7.08608L1.63606 0.721576C1.44056 0.526076 1.12406 0.526076 0.929064 0.721576L0.222064 1.42858C0.0265645 1.62408 0.0265645 1.94058 0.222064 2.13558L6.58606 8.50008L0.222064 14.8646C0.0270645 15.0601 0.0270645 15.3766 0.222064 15.5716L0.929064 16.2786C1.12456 16.4741 1.44106 16.4741 1.63606 16.2786L8.00006 9.91408L14.3641 16.2786C14.5596 16.4741 14.8761 16.4741 15.0711 16.2786L15.7781 15.5716C15.9736 15.3761 15.9736 15.0596 15.7781 14.8646L9.41406 8.50008L15.7781 2.13558C15.9731 1.94008 15.9731 1.62358 15.7781 1.42858L15.0711 0.721576C14.8756 0.526076 14.5591 0.526076 14.3641 0.721576Z" fill="#757575"/>
    </svg>
  </button>
</label>

<mat-divider></mat-divider>
<div>
  <div class="">
    <mat-dialog-content class="select-certificate">
      <div class="" style="margin-top: 32px">
        <div class="col-12 mb-3">
                    <span
                      style="margin-bottom: 1em; font-family: inherit; display: inline-block;color: rgba(0, 0, 0, 0.88) !important;">
                      {{'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}} </span>
          <br />
          <mat-radio-group #typeCertificateSelect id="typeCertificate" [(ngModel)]="typeSelectCertificate"
                           (change)="onChangeSelectCertificateType($event.value)" name="typeCertificate"
                           #typeCertificate="ngModel" required maxlength="100" style="display: flex; flex-direction: column; width: 100%;">
            <mat-radio-button [value]="signMethod.SIGN_CLOUD_CA" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca' | translate}}
            </mat-radio-button>

            <mat-radio-button [value]="signMethod.SIGN_USB_TOKEN" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_usb' | translate}}
            </mat-radio-button>
            <mat-radio-button [value]="signMethod.SIGN_SIM_CA" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca' | translate}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </mat-dialog-content>

    <!-- *********_SimCA_********* -->
    <!-- số điện thoại -->
    <div class="row usb-custom margin-none" *ngIf="typeSelectCertificate == 2">
      <div class="col-lg-4 col-sm-6 mt-3">
        <mat-form-field class="w-100">
          <span matPrefix>+84 &nbsp;</span>
          <input matInput (focusout)="simCaPhoneNumber=simCaPhoneNumber.trim()" type="text"
                 placeholder="{{'digital_certificate_management.lbl_phone' | translate}}"
                 [(ngModel)]="simCaPhoneNumber" name="phoneNumber" #phoneNumber="ngModel" [maxlength]="maxLengthPhone" required>
          <button mat-button *ngIf="simCaPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                  (click)="simCaPhoneNumber=null">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="phoneNumber.invalid">
                      <span class="text-error" *ngIf="phoneNumber?.errors?.required">
                        {{'validation.phone_number_re' | translate}}
                      </span>
            <span class="text-error" *ngIf="phoneNumber?.errors?.validInput">
                        {{'validation.phone_format' | translate}}
                      </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center">
        <button mat-raised-button type="button" class="get-cts" [disabled]="!simCaPhoneNumber"
                (click)="getCertificateOfSimCA()" color="primary">
          <mat-icon class="mr-0">list</mat-icon>
          {{'button.get_list' | translate}}
        </button>
      </div>
    </div>
    <!-- danh sách CTS-->
    <div class="col-12 mobile-p0" *ngIf="typeSelectCertificate == 2 && listOfDataSimCa.length > 0">
      <nz-table [nzData]="listOfDataSimCa" #dynamicTable nzShowPagination="false" nzBordered="true">
        <thead>
        <tr>
          <th></th>
          <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
          <th>{{'headertable.tax_code_no' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-data [ngForOf]="dynamicTable.data">
          <tr>
            <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCert($event,data)">
            </td>
            <td>{{data.STT}}</td>
            <td>{{data.certificateName}}</td>
            <td>{{data.serialNumber}}</td>
            <td>{{data.taxCode}}</td>
            <td>{{data.activeDate | dateformat}}</td>
            <td>{{data.expireDate | dateformat}}</td>
          </tr>
        </ng-template>

        </tbody>
      </nz-table>
    </div>
    <!--*************** end SimCa **************-->
    <!-- *******_USB-Token_******* -->
    <!-- cách tải lên-->
    <div class="row margin-none">
      <div class="col-lg-8 col-sm-12">
        <div class="mb-2" style="top: 2rem;" *ngIf="typeSelectCertificate == 1">
          <!-- tải lên từ Usb-Token -->
          <ng-container *ngIf="typeSelectCertificate == 1" #uploadFromUsb>
            <div>
              <button class="mb-3" mat-stroked-button color="primary" (click)="onGetCertificate()"
                      type="button">
                <mat-icon class="mr-0">usb</mat-icon>
                {{'digital_certificate_management.upload_usb_token' | translate}}
              </button>
            </div>

            <mat-error>
                        <span class="text-error" *ngIf="errorStatus != null">
                          <ng-container *ngIf="errorStatus != 'messages.not_initPlugin'; else errorInitPlugin">
                            {{ errorStatus | translate}}
                          </ng-container>
                          <ng-template #errorInitPlugin>
                            <ng-container>
                              {{ 'messages.not_initPlugin' | translate}}
                            </ng-container>
                            <br>
                            <ng-container>
                              {{ 'messages.check_input_usbtoken' | translate}}
                            </ng-container>
                            <br>
                            <ng-container>
                              {{ 'messages.check_input_software' | translate}}
                              <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                                <span style="cursor: pointer;">{{ 'messages.win' |
                                  translate}} </span>
                              </a>
                              <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                                <span style="cursor: pointer;">{{ 'messages.mac' |
                                  translate}} </span>
                              </a>
                              <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                                <span style="cursor: pointer;">{{ 'messages.linux' |
                                  translate}} </span>
                              </a>
                            </ng-container>

                          </ng-template>
                        </span>
            </mat-error>
          </ng-container>
        </div>
      </div>
    </div>

    <!--            CLOUD CA-->
    <form>
      <div class="row margin-none" *ngIf="typeSelectCertificate == 4">
        <div class="col-lg-4 col-sm-6 mt-3">
          <div>
            <mat-form-field>
              <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
              <mat-select #providerSelect (focusout)="(checkFocus = true)"
                          (focus)="commonService.openComboBox(checkFocus, providerSelect)" id="providerSelect"
                          [(ngModel)]="providerName" (selectionChange)="checkFocus = false;" #provider="ngModel"
                          required name="providerSelect">
                <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name"
                            (click)="this.commonService.closeDropdownList(this.providerSelect)">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 mt-3" *ngIf="typeSelectCertificate == 4">
          <mat-form-field class="w-100">
            <input matInput type="text"
                   placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                   (focusout)="cloudCaUsername = cloudCaUsername.trim()" [(ngModel)]="cloudCaUsername"
                   name="cloudCaUsername" #cloudCaUserId="ngModel"
                   [ngClass]="{ 'is-invalid': cloudCaUserId.invalid }" maxlength="200" required>
            <button mat-button *ngIf="cloudCaUsername" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="cloudCaUsername=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="cloudCaUserId.invalid">
                        <span class="text-error" *ngIf="cloudCaUserId?.errors?.required">
                          {{'validation.account_cloudca_required' | translate}}
                        </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-sm-6 d-flex justify-content-start align-items-center"
             *ngIf="typeSelectCertificate == 4">
          <button mat-raised-button type="button" [disabled]="!cloudCaUsername || !providerName "
                  (click)="getCertificateCloudCa()" color="primary">
            <mat-icon class="mr-0">list</mat-icon>
            {{'button.get_list' | translate}}
          </button>
        </div>
      </div>
    </form>

    <!--             danh sách CTS-->
    <div class="col-12" *ngIf="typeSelectCertificate == 4 && cloudCaDataSource.length > 0" style="margin-bottom: 32px">
      <nz-table [nzData]="cloudCaDataSource" #dynamicTable2 nzShowPagination="false" nzBordered="true">
        <thead>
        <tr>
          <th></th>
          <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
          <th>{{'headertable.tax_code_no' | translate}}</th>
          <th>{{'digital_certificate_management.cloud_ca_acc' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
          <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-data [ngForOf]="dynamicTable2.data">
          <tr>
            <td nzShowCheckbox [(nzChecked)]="data.checked"
                (nzCheckedChange)="onSelectedCloudCaCert($event,data)">
            </td>
            <td>{{data.STT}}</td>
            <td>{{data.certificateName}}</td>
            <td>{{data.serialNumber}}</td>
            <td>{{data.taxCode}}</td>
            <td>{{data.cloudCaUserId}}</td>
            <td>{{data.activeDate | dateformat}}</td>
            <td>{{data.expireDate | dateformat}}</td>
          </tr>
        </ng-template>

        </tbody>
      </nz-table>
    </div>
    <!--            ******** END CLOUD CA *********-->
    <!-- Tôi đã đọc, hiểu rõ, đồng ý và cam kết tuân thủ các Điều khoản -->

    <div class="row usb-custom margin-none" *ngIf="typeSelectCertificate === 1 && this.usbTokenCertificate.issuedTo">
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text" placeholder="{{'digital_certificate_management.public_by' | translate}}"
                 [value]="usbTokenCertificate.issuedBy" id="cert_Issuer" readonly>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text"
                 placeholder="{{'digital_certificate_management.cer_subject_name' | translate}}"
                 [value]="usbTokenCertificate.issuedTo" id="cert_CN" readonly>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text"
                 placeholder="{{'digital_certificate_management.serial_number' | translate}}"
                 [value]="usbTokenCertificate.serialNumber" id="cert_SNB" readonly>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text" placeholder="{{'digital_certificate_management.mst_cmnd' | translate}}"
                 [value]="usbTokenCertificate.taxCode" id="taxcode" readonly>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text"
                 placeholder="{{'digital_certificate_management.start_date' | translate}}"
                 [value]="usbTokenCertificate.activeDate | date: 'dd/MM/yyyy'" id="cert_ValidFrom" readonly>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <input matInput type="text" placeholder="{{'digital_certificate_management.end_date' | translate}}"
                 [value]="usbTokenCertificate.expireDate | date: 'dd/MM/yyyy'" id="cert_ValidTo" readonly>
        </mat-form-field>
      </div>
      <div class="col-6 d-none">
        <mat-form-field class="w-100">
          <input matInput type="text" placeholder="Raw Data" [value]="usbTokenCertificate.certRawdata"
                 id="cert_rawData" readonly>
        </mat-form-field>
      </div>
    </div>
    <!-- ********** end Usb Token ************-->
    <div class="col-12 text-noti">
      {{'verify-enterprice.notice'| translate}}
    </div>
  </div>

  <mat-dialog-actions align="center" style="margin-top: 32px" class=" pb-3">
    <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
            (click)="onClickBtnCancel()">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button color="primary" class="mr-3" (click)="onClickSignButton()"
    [disabled]="typeCertificate.invalid || isDisableNextButton"
    >
      <mat-icon class="mr-0">check</mat-icon>
      {{'button.confirm_info' | translate}}
    </button>
  </mat-dialog-actions>
</div>
